module.exports = __webpack_public_path__ + "static/media/combined.b39fc911.mp4";